// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1e0c1ule{display:block}
._4t3i1rxo{height:var(--_1fywwk4)}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/link-picker/dist/esm/common/generic-error-svg/index.compiled.css"],"names":[],"mappings":"AAAA,WAAW,aAAa;AACxB,WAAW,sBAAsB","sourcesContent":["._1e0c1ule{display:block}\n._4t3i1rxo{height:var(--_1fywwk4)}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
